export const isEmptyString = (data) => {
    return (
        data === '' || 
        data === undefined || 
        data === null
    );
}

export function isEmpty(value) {
    return (
      value == null || // Checks for null or undefined
      (typeof value === "string" && value.trim().length === 0) || // Empty string
      (Array.isArray(value) && value.length === 0) || // Empty array
      (typeof value === "object" && Object.keys(value).length === 0) // Empty object
    );
  }

  export function isEmptyNumber(value, treatZeroAsEmpty = false) {
    return (
      value == null || // Checks for null or undefined
      isNaN(value) || // Checks for NaN
      (treatZeroAsEmpty && value === 0) // Optionally consider 0 as empty
    );
  }